
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { BatchExecuteDetail, BatchExecuteDetailParams, PeddingMedicalTreatmentDetail, PeddingMedicalTreatmentList, PeddingMedicalTreatmentParams, PeddingMedicalTreatmentRecordDetail, PeddingMedicalTreatmentRecordDetailParams, XMPageList } from "../../../services/peddingMedicalTreatment";

// 列表
export const getPeddingMedicalTreatmentList = createAsyncThunk<
  void,
  PeddingMedicalTreatmentParams,
  RootThunkApi<void>
>("medicalstation/peddingMedicalTreatment", async (params, api) => {
  return sendAsync( PeddingMedicalTreatmentList(params), api);
});

// 获取项目列表
export const getXMPageList = createAsyncThunk<
  void,
  PeddingMedicalTreatmentParams,
  RootThunkApi<void>
>("medicalstation/xmPageList", async (params, api) => {
  return sendAsync( XMPageList(params), api);
});

// 获取右侧详情
export const getPeddingMedicalTreatmentDetail = createAsyncThunk<
  void,
  PeddingMedicalTreatmentParams,
  RootThunkApi<void>
>("medicalstation/peddingMedicalTreatmentDetail", async (params, api) => {
  return sendAsync( PeddingMedicalTreatmentDetail(params), api);
});

// 查询单个执行详情
export const getPeddingMedicalTreatmentRecordDetail = createAsyncThunk<
  void,
  PeddingMedicalTreatmentRecordDetailParams,
  RootThunkApi<void>
>("medicalstation/peddingMedicalTreatmentRecordDetail", async (params, api) => {
  return sendAsync( PeddingMedicalTreatmentRecordDetail(params), api);
});

// 保存
export const getBatchExecuteDetail = createAsyncThunk<
  void,
  BatchExecuteDetailParams,
  RootThunkApi<void>
>("medicalstation/getBatchExecuteDetail", async (params, api) => {
  return sendAsync( BatchExecuteDetail(params), api);
});